import { render, staticRenderFns } from "./ViewModeSwitch.vue?vue&type=template&id=1dcf61aa&scoped=true&"
import script from "./ViewModeSwitch.vue?vue&type=script&lang=js&"
export * from "./ViewModeSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcf61aa",
  null
  
)

export default component.exports